export default "__VITE_ASSET__Clj2MCUv__"